export default __webpack_public_path__ + "static/media/daemon-diagram.49ba3af4.jpg";